const DEFAULT_COOKIE_OPTIONS = {
  maxAge: 60 * 60 * 24 * 30,
  path: '/',
};

export { DEFAULT_COOKIE_OPTIONS };
